import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import "./Success.css";

function Success() {
  const navigate = useNavigate();
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
      navigate("/");
    }, 8000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="success-container">
      {showConfetti && <Confetti className="confetti-canvas" />}
      
      <div className="success-card">
        <h2 className="success-title">
          🎉 Order Placed Successfully 🎉
        </h2>
        <p className="success-text">
          🎉 Thanks for shopping with us! Your order is on the way!
        </p>
      </div>
    </div>
  );
}

export default Success;